// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'__fedraSansStdAMedium_dc4070', '__fedraSansStdAMedium_Fallback_dc4070'"},"className":"__className_dc4070","variable":"__variable_dc4070"};